/**
 * Deneme deneme detay.
 *
 * Raporun özet cümlesi "dizi uzunluğunda 3,4 basamak düzeyinde çalıştı"
 * diyor; uygulayıcının sorduğu soru ise şu: kaçırdığı denemede SIRA mı
 * karıştı, son basamak mı düştü, yoksa hiç mi alakasızdı? Üçü üç ayrı
 * bulgu ve özet sayı üçünü de aynı gösteriyor.
 *
 * Bu yüzden her görev kendi diliyle gösteriliyor. Ortak bir "uyarıcı /
 * cevap" tablosu teknik olarak daha kolaydı ama "9,4,2,5 → 9,4,5,2"
 * satırı kimseye bir şey anlatmaz; ızgarada hangi kutu kaçıncı sırada
 * yandı, onu görmek gerekiyor.
 *
 * VELİYE KAPALI: bu veri veli bağlamında veritabanından okunamıyor.
 * Çocuğa da gösterilmiyor.
 */

import { useState } from 'react'
import {
  GECERSIZLIK_ADI,
  SONUC_ADI,
  api,
  type Deneme,
} from '../api'

const YON_ADI: Record<string, string> = { sol: 'sol', sag: 'sağ' }
const OK: Record<string, string> = { sol: '←', sag: '→' }

function dizi(v: string | string[] | null | undefined): string[] {
  if (v == null) return []
  return Array.isArray(v) ? v : [v]
}

/* ------------------------------------------------------------------ */

/**
 * Izgara: hangi kutu kaçıncı sırada.
 *
 * Numara, kutunun sırasını gösteriyor. Yanlış sıradaki kutu kırmızı
 * çerçeveli: "doğru kutu ama yanlış sıra" ile "hiç basılmamış kutu"
 * arasındaki farkı tek bakışta görmek gerekiyor.
 */
function Izgara({
  boyut,
  sira,
  dogruSira,
  baslik,
}: {
  boyut: number
  sira: string[]
  /** Karşılaştırma için beklenen sıra; verilmezse işaretleme yapılmaz */
  dogruSira?: string[]
  baslik: string
}) {
  const yer = new Map(sira.map((h, i) => [h, i + 1]))
  return (
    <div>
      <div className="alt" style={{ margin: '0 0 6px' }}>
        {baslik}
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${boyut}, 28px)`,
          gap: 3,
        }}
      >
        {Array.from({ length: boyut * boyut }, (_, i) => {
          const h = String(i)
          const n = yer.get(h)
          const beklenenYer = dogruSira ? dogruSira.indexOf(h) + 1 : 0
          const yanlisSira = Boolean(n && beklenenYer && n !== beklenenYer)
          const fazladan = Boolean(n && dogruSira && beklenenYer === 0)
          return (
            <div
              key={h}
              style={{
                height: 28,
                display: 'grid',
                placeItems: 'center',
                fontSize: 12,
                fontWeight: 600,
                borderRadius: 6,
                border: '1px solid',
                borderColor: n
                  ? yanlisSira || fazladan
                    ? 'var(--bad)'
                    : 'var(--accent)'
                  : 'var(--line)',
                background: n
                  ? yanlisSira || fazladan
                    ? 'var(--soft-bad)'
                    : 'var(--soft-accent)'
                  : '#fff',
                color: n ? (yanlisSira || fazladan ? 'var(--bad)' : 'var(--accent)') : 'transparent',
              }}
            >
              {n ?? '·'}
            </div>
          )
        })}
      </div>
    </div>
  )
}

function DiziDenemesi({ d }: { d: Deneme }) {
  const u = (d.uyarici ?? {}) as { gridSize?: number }
  const boyut = Number(u.gridSize ?? 4)
  const gosterilen = dizi(d.beklenen)
  const basilan = dizi(d.cevap)

  return (
    <div
      style={{
        display: 'flex',
        gap: 20,
        flexWrap: 'wrap',
        padding: '12px 0',
        borderTop: '1px solid var(--line)',
      }}
    >
      <div style={{ minWidth: 150 }}>
        <strong>{d.sira + 1}. deneme</strong>
        <div className="alt" style={{ margin: '2px 0 0' }}>
          {gosterilen.length} basamak · düzey {d.duzey}
        </div>
        <div style={{ marginTop: 6 }}>
          <span className={'rozet' + (d.sonuc === 'hit' ? ' ok' : ' bad')}>
            {d.sonuc === 'hit' ? 'Doğru' : 'Yanlış'}
          </span>
        </div>
        {d.tepkiMs !== null && (
          <div className="alt" style={{ margin: '6px 0 0' }}>
            {Math.round(d.tepkiMs)} ms
          </div>
        )}
        {!d.gecerli && d.gecersizlikSebebi && (
          <div style={{ color: 'var(--bad)', fontSize: 12, marginTop: 4 }}>
            geçersiz: {GECERSIZLIK_ADI[d.gecersizlikSebebi] ?? d.gecersizlikSebebi}
          </div>
        )}
      </div>

      <Izgara boyut={boyut} sira={gosterilen} baslik="Sistem yaktı" />
      {basilan.length > 0 ? (
        <Izgara
          boyut={boyut}
          sira={basilan}
          dogruSira={gosterilen}
          baslik="Çocuk bastı"
        />
      ) : (
        <div>
          <div className="alt" style={{ margin: '0 0 6px' }}>
            Çocuk bastı
          </div>
          <div className="alt" style={{ margin: 0 }}>
            hiç basmadı
          </div>
        </div>
      )}

      <div style={{ minWidth: 150 }}>
        <div className="alt" style={{ margin: '0 0 4px' }}>
          Sıra
        </div>
        <div style={{ fontSize: 13 }}>
          <div>
            Yakılan: <strong>{gosterilen.map((h) => Number(h) + 1).join(' → ')}</strong>
          </div>
          <div style={{ marginTop: 4 }}>
            Basılan:{' '}
            <strong>
              {basilan.length ? basilan.map((h) => Number(h) + 1).join(' → ') : '—'}
            </strong>
          </div>
        </div>
      </div>
    </div>
  )
}

/* ------------------------------------------------------------------ */

function BasBasmaSatiri({ d }: { d: Deneme }) {
  const u = (d.uyarici ?? {}) as { letter?: string; n?: number }
  return (
    <tr style={{ opacity: d.gecerli ? 1 : 0.55 }}>
      <td>{d.sira + 1}</td>
      <td style={{ fontWeight: 700, fontSize: 16 }}>{u.letter ?? '—'}</td>
      <td>{d.hedefMi ? 'Basmalıydı' : 'Beklemeliydi'}</td>
      <td>{d.tepkiMs !== null ? 'Bastı' : 'Basmadı'}</td>
      <td>{d.tepkiMs !== null ? `${Math.round(d.tepkiMs)} ms` : '—'}</td>
      <td>
        <span
          className={
            'rozet' + (d.sonuc === 'hit' || d.sonuc === 'correct_rejection' ? ' ok' : ' bad')
          }
        >
          {SONUC_ADI[d.sonuc ?? ''] ?? d.sonuc ?? '—'}
        </span>
      </td>
      <td style={{ color: 'var(--bad)', fontSize: 12 }}>
        {!d.gecerli && d.gecersizlikSebebi
          ? (GECERSIZLIK_ADI[d.gecersizlikSebebi] ?? d.gecersizlikSebebi)
          : ''}
      </td>
    </tr>
  )
}

function SecimSatiri({ d }: { d: Deneme }) {
  const u = (d.uyarici ?? {}) as {
    kind?: string
    dir?: string
    flank?: string
    flankerCount?: number
    congruent?: boolean
    target?: string
    gridSize?: number
    rule?: string
    color?: string
    shape?: string
    isSwitch?: boolean
  }
  const beklenen = dizi(d.beklenen)[0] ?? '—'
  const verilen = dizi(d.cevap)[0]

  let gosterim: React.ReactNode = '—'
  let durum = ''

  if (u.kind === 'flanker') {
    const yan = OK[u.flank ?? ''] ?? '?'
    const orta = OK[u.dir ?? ''] ?? '?'
    const kenar = Math.max(0, Math.floor((u.flankerCount ?? 0) / 2))
    gosterim = (
      <span style={{ letterSpacing: '0.15em', fontSize: 16 }}>
        {yan.repeat(kenar)}
        <strong style={{ color: 'var(--accent)' }}>{orta}</strong>
        {yan.repeat(kenar)}
      </span>
    )
    durum = u.congruent ? 'uyumlu' : 'çeldiricili'
  } else if (u.kind === 'symbol_search') {
    gosterim = (
      <span>
        aranan <strong style={{ fontSize: 16 }}>{u.target}</strong> · {u.gridSize}×{u.gridSize}
      </span>
    )
    durum = d.hedefMi ? 'ızgarada vardı' : 'ızgarada yoktu'
  } else if (u.kind === 'rule_switch') {
    gosterim = (
      <span>
        kural <strong>{u.rule}</strong> · {u.color} {u.shape}
      </span>
    )
    durum = u.isSwitch ? 'kural değişti' : 'kural aynı'
  }

  const dogru = verilen !== undefined && verilen === beklenen

  return (
    <tr style={{ opacity: d.gecerli ? 1 : 0.55 }}>
      <td>{d.sira + 1}</td>
      <td>{gosterim}</td>
      <td className="alt" style={{ margin: 0 }}>
        {durum}
      </td>
      <td>{YON_ADI[beklenen] ?? beklenen}</td>
      <td>{verilen === undefined ? '—' : (YON_ADI[verilen] ?? verilen)}</td>
      <td>{d.tepkiMs !== null ? `${Math.round(d.tepkiMs)} ms` : '—'}</td>
      <td>
        <span className={'rozet' + (dogru ? ' ok' : ' bad')}>
          {verilen === undefined ? 'Cevap yok' : dogru ? 'Doğru' : 'Yanlış'}
        </span>
      </td>
      <td style={{ color: 'var(--bad)', fontSize: 12 }}>
        {!d.gecerli && d.gecersizlikSebebi
          ? (GECERSIZLIK_ADI[d.gecersizlikSebebi] ?? d.gecersizlikSebebi)
          : ''}
      </td>
    </tr>
  )
}

/* ------------------------------------------------------------------ */

export function DenemeDetayi({ olcumId, gorev }: { olcumId: string; gorev: string }) {
  const [denemeler, setDenemeler] = useState<Deneme[] | null>(null)
  const [toplam, setToplam] = useState(0)
  const [hata, setHata] = useState<string | null>(null)
  const [acik, setAcik] = useState(false)

  const ac = async () => {
    setAcik(true)
    if (denemeler) return
    try {
      const r = await api.denemeler(olcumId, gorev)
      setDenemeler(r.denemeler)
      setToplam(r.toplam)
    } catch {
      setHata('Deneme detayı alınamadı.')
      setDenemeler([])
    }
  }

  if (!acik) {
    return (
      <div className="dugmeler" style={{ marginTop: 10 }}>
        <button onClick={() => void ac()}>Deneme detayını göster</button>
      </div>
    )
  }

  if (hata) return <div className="uyari">{hata}</div>
  if (!denemeler) return <p className="alt">Yükleniyor…</p>
  if (denemeler.length === 0) {
    return (
      <div className="bilgi">
        Bu görevde kayıtlı deneme detayı yok. Ölçüm, detay kaydı eklenmeden önce yapılmış
        olabilir.
      </div>
    )
  }

  const diziGorevi = gorev === 'span_visual'
  const basBasma = gorev === 'cpt' || gorev === 'nback'

  return (
    <div style={{ marginTop: 10 }}>
      <div className="dugmeler" style={{ marginTop: 0, marginBottom: 8 }}>
        <button onClick={() => setAcik(false)}>Detayı gizle</button>
        <span className="alt" style={{ margin: 0, alignSelf: 'center' }}>
          {denemeler.length} / {toplam} deneme
        </span>
      </div>

      {diziGorevi ? (
        <div>
          {denemeler.map((d) => (
            <DiziDenemesi key={`${d.gorev}-${d.sira}`} d={d} />
          ))}
        </div>
      ) : basBasma ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Harf</th>
              <th>Olması gereken</th>
              <th>Yaptığı</th>
              <th>Süre</th>
              <th>Sonuç</th>
              <th>Not</th>
            </tr>
          </thead>
          <tbody>
            {denemeler.map((d) => (
              <BasBasmaSatiri key={`${d.gorev}-${d.sira}`} d={d} />
            ))}
          </tbody>
        </table>
      ) : (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Gösterilen</th>
              <th>Durum</th>
              <th>Doğrusu</th>
              <th>Seçtiği</th>
              <th>Süre</th>
              <th>Sonuç</th>
              <th>Not</th>
            </tr>
          </thead>
          <tbody>
            {denemeler.map((d) => (
              <SecimSatiri key={`${d.gorev}-${d.sira}`} d={d} />
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
